import { handbookContractorsAPI } from "@/views/handbook/contractors/api";

export const getHandbookContractors = async (params) => {
  try {
    const res = await handbookContractorsAPI.getList(params);
    return res?.data;
  } catch (e) {}
};

export const sendTo1C = async (contractor_id, is_send_to_1c) => {
  try {
    const response = await handbookContractorsAPI.sendTo1C(
      contractor_id,
      is_send_to_1c
    );
    return response?.data;
  } catch (error) {}
};

export const addHandbookContractor = async (body = {}) => {
  const formData = new FormData();

  Object.entries(body).forEach(([key, value]) => {
    if (key === "document" && value?.length) {
      formData.append(key, value[0]);
    } else {
      formData.append(key, value);
    }
  });

  try {
    const res = await handbookContractorsAPI.addContractor(formData);
    return res?.data;
  } catch (e) {}
};

export const updateHandbookContractor = async (contractor_id, body = {}) => {
  const formData = new FormData();

  Object.keys(body).map((key) => {
    if (key === "document" && body.document?.length) {
      formData.append(key, body.document[0]);
    } else formData.append(key, body[key]);
  });
  try {
    const res = await handbookContractorsAPI.updateContractor(
      contractor_id,
      formData
    );
    return res?.data;
  } catch (e) {}
};
export const deleteHandbookContractor = async (contractor_id) => {
  try {
    const res = await handbookContractorsAPI.deleteContractor(contractor_id);
    return res?.data;
  } catch (e) {}
};
export const getCity = async () => {
  try {
    const res = await handbookContractorsAPI.getCity();
    return res?.data;
  } catch (e) {}
};
export const getTaxopark = async () => {
  try {
    const res = await handbookContractorsAPI.getTaxopark();
    return res?.data;
  } catch (e) {}
};
export const getContractorType = async () => {
  try {
    const res = await handbookContractorsAPI.getContractorType();
    return res?.data;
  } catch (e) {}
};
export const getContragentType = async () => {
  try {
    const res = await handbookContractorsAPI.getContragentType();
    return res?.data;
  } catch (e) {}
};
export const getContractorMainType = async () => {
  try {
    const res = await handbookContractorsAPI.getContractorMainType();
    return res?.data;
  } catch (e) {}
};

export const mapSBSCompany = async (body) => {
  try {
    const res = await handbookContractorsAPI.mapSBSCompany(body);
    return res?.data;
  } catch (e) {}
};

export const mapSBSPartner = async (body) => {
  try {
    const res = await handbookContractorsAPI.mapSBSPartner(body);
    return res?.data;
  } catch (e) {}
};

// Поля director_fio / city_name приходят из БД склеенными через <br/> (ФИО + счётчики,
// статус договора + дата + город) — для строки в одну линию и просмотра берём части по отдельности.
export const contractorActiveRemonts = (row) => {
  const html = row.director_fio || ''
  const contractor = html.match(/Подрядчик в активных ремонтах:\s*(\d+)/)
  const general = html.match(/Ген подрядчик в активных ремонтах:\s*(\d+)/)
  if (!contractor && !general) return ''
  return `${contractor ? contractor[1] : 0} / ${general ? general[1] : 0}`
}
export const contractorJoinDate = (row) => (row.city_name || '').match(/Дата присоединения:\s*([\d.]+)/)?.[1] || ''
export const contractorCityName = (row) => {
  const parts = (row.city_name || '').split(/<br\s*\/?>/i)
  return parts[parts.length - 1].replace(/<[^>]*>/g, '').trim()
}

// viewValue / viewTitle — для режима просмотра строки (CustomTable, openRowView)
export const contractorsHandbookColumns = [
  { name: "actions", field: "actions", label: "", align: "left" },
  { name: "contractor_id", field: "contractor_id", label: "ID", align: "left" },
  { name: "contractor_name", field: "contractor_name", label: "Наименование", align: "left", viewTitle: true },
  { name: "director_fio", field: "director_fio_myspace", label: "ФИО директора", align: "left" },
  { name: "active_remonts", field: "active_remonts", label: "В ремонтах", align: "center", viewValue: (r) => contractorActiveRemonts(r) && `${contractorActiveRemonts(r)} (подрядчик / генподрядчик)` },
  { name: "accession", field: "accession", label: "Договор присоединения", align: "left", viewValue: (r) => `${r.is_signed_accession_contract ? "Подписан" : "Не подписан"}${contractorJoinDate(r) ? `, ${contractorJoinDate(r)}` : ""}` },
  { name: "city_name", field: "city_name", label: "Город", align: "left", viewValue: contractorCityName },
  { name: "documents", field: "documents", label: "Документ", align: "left", viewValue: (r) => (r.accession_contract_url ? "Файл загружен" : "") },
  { name: "legal_name", field: "legal_name", label: "Юр. наименование", align: "left" },
  { name: "bin", field: "bin", label: "БИН", align: "left" },
  { name: "address", field: "address", label: "Адрес", align: "left" },
  { name: "contacts", field: "contacts", label: "Контакты", align: "left" },
  { name: "iik", field: "iik", label: "ИИК", align: "left" },
  { name: "account_name", field: "account_name", label: "Банк. счёт", align: "left" },
  { name: "bik", field: "bik", label: "БИК", align: "left" },
  { name: "contract_text", field: "contract_text", label: "Текст для договора", align: "left" },
  { name: "accession_contract_num", field: "accession_contract_num", label: "Договор", align: "left", viewValue: (r) => [r.accession_contract_num && `№${r.accession_contract_num}`, r.accession_contract_date && `от ${r.accession_contract_date}`].filter(Boolean).join(" ") },
  { name: "phone", field: "phone", label: "Телефон", align: "left" },
  { name: "email", field: "email", label: "Email", align: "left" },
  { name: "is_send_to_1c_text", field: "is_send_to_1c_text", label: "1С", align: "left" },
];
